import React from 'react';

import InfoCircle from '@decisiv/iconix/lib/components/InfoCircle';
import Message from '@decisiv/ui-components/lib/components/Message';

import { EmptyStateArea, TableDivider } from './styles';

/**
 * Shown when there are no users to list at all (Figma 787:78031).
 *
 * The mockup drops both the column headers and the table footer here, leaving a
 * divider where the header row would be and a centred Message below it. That is
 * deliberately different from the "No Matches" state (787:78141), which keeps
 * the headers and the footer because a search or filter is active and the user
 * needs those controls to get back to results. See UsersNoMatches.
 *
 * KeyDS Message directly rather than pages/Users/components/EmptyState — that
 * one sits on the legacy grey `fullMoon` panel, and this area is white.
 */
function UsersEmptyState() {
  return (
    <>
      <TableDivider />
      <EmptyStateArea>
        <Message
          color="licoriceMousse"
          icon={InfoCircle}
          size="large"
          title="No Users Yet"
          variant="vertical"
        >
          Click Create User to add new Users to this Account.
        </Message>
      </EmptyStateArea>
    </>
  );
}

export default UsersEmptyState;
